import { createElement } from 'react';
import './index.scss';
const Tag = ({ name, color, ...otherProps }) => {
    return (createElement("span", { className: `tags__container ${color ? color : ''}`, ...otherProps }, name));
};
export default Tag;
